import AdminActiveEventStrip from "../../components/admin/AdminActiveEventStrip";
import EventProductExcelPanel from "../../components/admin/EventProductExcelPanel";
import ParcelProductExcelPanel from "../../components/admin/ParcelProductExcelPanel";
import { useAdminActiveEvent } from "../../hooks/useAdminActiveEvent";

export default function ProductRegister() {
  const { active, noneActive, loadingActive, loadError, loadActive } =
    useAdminActiveEvent();

  return (
    <div className="md:mx-2 p-4 space-y-6">
      <AdminActiveEventStrip
        active={active}
        noneActive={noneActive}
        loading={loadingActive}
        loadError={loadError}
        onRefresh={() => void loadActive()}
      />
      <EventProductExcelPanel active={active} loadingActive={loadingActive} />
      <ParcelProductExcelPanel
        active={active}
        loadingActive={loadingActive}
      />
    </div>
  );
}
